import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13ee5292"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal is-active",
  ref: "recurrentContract"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "modal-card"
}
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = { class: "modal-card-body" }
const _hoisted_7 = { class: "body-content is-size-4" }
const _hoisted_8 = { class: "custom-card-title has-text-weight-bold" }
const _hoisted_9 = { class: "confirm-icon-container" }
const _hoisted_10 = { class: "amount-details mb-3" }
const _hoisted_11 = { class: "amount is-size-3 has-text-weight-bold" }
const _hoisted_12 = { class: "frame3-sub-title" }
const _hoisted_13 = { class: "frame3-sub-title has-text-weight-bold is-size-3 hide-overflow" }
const _hoisted_14 = { class: "frame3-sub-title" }
const _hoisted_15 = { class: "frame3-sub-title has-text-weight-bold is-size-3 hide-overflow" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "participant-divider" }, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "contract-description"
}
const _hoisted_18 = { class: "message-text is-size-5" }
const _hoisted_19 = {
  key: 1,
  class: "contract-summary is-size-5 mb-3"
}
const _hoisted_20 = { class: "recurrence-payment" }
const _hoisted_21 = { class: "contract-summary date-range mb-3" }
const _hoisted_22 = { class: "is-size-5" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  key: 2,
  class: "contract-summary is-size-5 mb-3"
}
const _hoisted_27 = { class: "contract-guidance is-size-5 mb-3" }
const _hoisted_28 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "icon"
}
const _hoisted_31 = {
  key: 1,
  class: "modal-card"
}
const _hoisted_32 = { class: "modal-card-head" }
const _hoisted_33 = { class: "is-flex is-flex-shrink-0" }
const _hoisted_34 = { class: "icon has-text-white" }
const _hoisted_35 = { class: "modal-card-title is-title-shrink" }
const _hoisted_36 = { class: "modal-card-body" }
const _hoisted_37 = { class: "body-content has-text-centered" }
const _hoisted_38 = { class: "is-size-5 mb-4" }
const _hoisted_39 = { class: "is-size-6 has-text-grey" }
const _hoisted_40 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.$modal.step.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.isCreateMode
                ? _ctx.$gettext("Create recurrent payment")
                : _ctx.$gettext("Recurrent payment details")), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.statusTitle), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_fa_icon, {
                  icon: _ctx.statusIcon,
                  class: _normalizeClass(["confirm-icon fa-thin", _ctx.isCreateMode ? 'new' : _ctx.contractData.state])
                }, null, 8, ["icon", "class"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.numericFormat(parseFloat(_ctx.contractData.amount))) + " " + _toDisplayString(_ctx.currency), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$gettext("from")), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.contractData.senderName), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$gettext("to")), 1),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.contractData.receiverName), 1)
              ]),
              _hoisted_16,
              (_ctx.contractData.message)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, "“" + _toDisplayString(_ctx.contractData.message) + "”", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.nextOccurrenceDate)
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.$gettext("Next:")) + " " + _toDisplayString(_ctx.formatDate(_ctx.nextOccurrenceDate)) + " ", 1),
                    _createElementVNode("span", _hoisted_20, " (" + _toDisplayString(_ctx.recurrencePaymentLabel) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", _hoisted_22, [
                  (_ctx.contractData.dateStart)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$gettext("From")) + " " + _toDisplayString(_ctx.formatDate(_ctx.contractData.dateStart)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.contractData.dateEnd)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(" ") + _toDisplayString(_ctx.$gettext("to")) + " " + _toDisplayString(_ctx.formatDate(_ctx.contractData.dateEnd)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(" ") + _toDisplayString(_ctx.$gettext("(no end date)")), 1))
                ])
              ]),
              (!_ctx.isCreateMode)
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.createdOnSentence), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_27, [
                _createElementVNode("em", null, _toDisplayString(_ctx.contractGuidance), 1)
              ])
            ])
          ]),
          _createElementVNode("footer", _hoisted_28, [
            (_ctx.isCreateMode)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button custom-button-modal has-text-weight-medium",
                  disabled: _ctx.isCreating,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createContract()))
                }, [
                  (_ctx.isCreating)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                        _createVNode(_component_fa_icon, {
                          icon: "circle-notch",
                          class: "refreshing"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Create recurrent payment")), 1)
                ], 8, _hoisted_29))
              : (_ctx.contractData.isCreator && _ctx.contractData.state === 'open')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button custom-button-modal has-text-weight-medium",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startDelete()))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Delete")), 1)
                  ]))
                : (_ctx.contractData.state === 'cancelled')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "button custom-button-modal has-text-weight-medium",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$modal.close()))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Ok")), 1)
                    ]))
                  : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$modal.step.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("header", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, [
              _createElementVNode("a", {
                class: "mr-3 is-flex",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$modal.back()))
              }, [
                _createElementVNode("span", _hoisted_34, [
                  _createVNode(_component_fa_icon, {
                    icon: "arrow-left",
                    class: "fa-lg"
                  })
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$gettext("Delete recurrent payment")), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$modal.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_fa_icon, {
                icon: "exclamation-triangle",
                class: "warning-icon mb-4"
              }),
              _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$gettext("Are you sure you want to delete this recurrent payment?")), 1),
              _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$gettext("This action cannot be undone.")), 1)
            ])
          ]),
          _createElementVNode("footer", _hoisted_40, [
            _createElementVNode("button", {
              class: "button custom-button-modal has-text-weight-medium",
              disabled: _ctx.isDeleting,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmDelete()))
            }, [
              (_ctx.isDeleting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                    _createVNode(_component_fa_icon, {
                      icon: "circle-notch",
                      class: "refreshing"
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Delete")), 1)
            ], 8, _hoisted_41)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}